import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import fb from '../../assets/facebook-logo-2428.png';
import yt from '../../assets/youtube-logo-2431.png'


const Footer = () => {
    return ( 
        <div>
            <Container style={{backgroundColor: 'black', maxWidth: "100vw"}}>
                <Row style={{padding: '20px'}}>
                    <Col sm={12} xl={4}>
                    <h5 style={{color: "white"}}>Contact Us: </h5>
                        <p style={{color: "white"}}>
                           Address: 217 Wheeler Ln, Crab Orchard, TN, United States, Tennessee
                        </p>
                        <p style={{color: "white"}}>
                           Phone: (931) 484-6111
                        </p>
                    </Col>
                    <Col sm={12} xl={4}>
                    
                    </Col>
                    <Col sm={12} xl={4} className="">
                    <h5 style={{color: "white"}}>Our Social Media:</h5>
                        <a href="https://www.facebook.com/CrabOrchardChristian" target="_blank">
                            <img src={fb} alt="Visit the Crab Orchard Christian Church Facebook Page" />
                        </a>
                        <a href="https://www.youtube.com/@craborchardbaptistchurch6635" target="_blank" style={{paddingLeft: "2rem"}}>
                            <img src={yt} alt="Visit the Crab Orchard Christian Church Youtube Page" style={{maxWidth: '10rem', maxHeight: '10rem'}}/>
                        </a>
                    </Col>
                </Row>
            </Container>
        </div>
     );
}
 
export default Footer;